import { ReactComponent as Logo } from 'assets/images/rein_logo.svg';
import { Box, Link, Typography, useTheme } from "@mui/material";

const Footer = () => {
	const theme = useTheme()
	return (
		<Box sx={{ mt: 5, mb: 5 }}>
			<Typography variant="body1" textAlign="center">
				Your info is being provided to
				REIN to create the quote <Link target="_blank" href="https://www.rein.ai/privacypolicy">
					Privacy Policy</Link>,
				&nbsp;<Link target="_blank" href="https://www.rein.ai/termsofservice">Do not sell
					or share my personal
					information</Link> REIN may receive a fee if you purchase the represented product
			</Typography>
			{theme.palette.assetUrl &&
				<Box textAlign="center" mt={2}><Logo width={171} height={40}/>
					<Typography variant="body1" fontSize="10px" lineHeight="12px">Renters Insurance powered by
						Assurant®</Typography></Box>
			}
		</Box>
	)
}

export default Footer
